"use client";

import styles from "../shared.module.css";

interface AuthCardProps {
  children: React.ReactNode;
}

/**
 * Glass card component for auth pages.
 * Logo is rendered externally by AuthPageLayout above the card.
 */
export function AuthCard({ children }: AuthCardProps) {
  return <div className={styles.card}>{children}</div>;
}
